module.exports = __webpack_public_path__ + "static/dashboard_intro2_en@2x-604eeb177863661626babd1af84adf8a.png";